// Navigation related
export const NAV_TITLE = 'Category Mgmt Tool';
export const MENDEL_BUSINESS_NAV_TITLE = 'Mendel';
export const GFC_BUSINESS_NAV_TITLE = 'GFC';
export const FEEDBACK_TEXT = 'Provide Feedback';
export const FRESH_BUSINESS_NAV_TITLE = 'AmazonFresh';

export const REPORT_ISSUE = 'Report Issue';

// My Assortment Tab related
export const CREATE_NEW_ASSORTMENT_TITLE = 'Create new assortment';
export const CREATE_NEW_ASSORTMENT_DESCRIPTION = 'Enter all required* details below to start curating';
export const MY_ASSORTMENT = 'My Assortment';
export const YEAR = 'Year';
export const YEAR_SELECTOR_PLACEHOLDER = 'Choose year';
export const SEASON = 'Season';
export const SEASON_SELECTOR_PLACEHOLDER = 'Choose season';
export const MERCH_LOCATION = 'Merch Location';
export const MERCH_LOCATION_SELECTOR_PLACEHOLDER = 'Choose merch location';
export const ASSORTMENT_TYPE = 'Assortment type';
export const BRAND = 'Brand';
export const SUB_MERCH_FULL = 'Sub-category';
export const SUB_MERCH_LOCATION_SELECTOR_PLACEHOLDER = 'Choose sub-category';
export const SUB_MERCH_SHORT = 'SubCat';
export const REQUIRED_ERROR_MESSAGE = 'is required';
export const NO_RESULT_MESSAGE = 'No results';

// SuperCat Tab related
export const EXPORT_UPLOAD = 'Export & Upload';
export const EXPORT_IN_PROGRESS = 'Exporting excel file...';
export const UPLOAD_IN_PROGRESS = 'Uploading excel file...';
export const SUPER_CAT_INFO = 'Please note, any forward buys will require all inputs manually.';
export const SAVE_CHANGES = 'Save changes';
export const DELETE_ASIN_ERROR_MESSAGE_ADD_INPROGRESS =
  'Can not delete this asin until we finish adding it to the server';
export const NO_ASSORTMENT_SELECTED = 'Please create/select an assortment from My Assortment page';
export const EXPORT_ISM_EXCEL_TAB_NAME = 'ISM';
export const EXPORT_PLACEHOLDER_EXCEL_TAB_NAME = 'Placeholders';
export const EXPORT_TO_AMT_TAB_NAME = 'AMT';
export const UPLOAD_FORECASTING = 'Upload forecasting';
export const IMPORT_NIS_MAPPING = 'Import NIS mapping';
export const BULK_EDIT = 'Bulk edit';
export const SELECT_ROWS = 'Select rows';

// Supercat Add Asin
export const ADD_NEW_ITEMS = 'Add new items';
export const ADD_NEW_ASINS = 'Add new asins';
export const ADD_NEW_PLACEHOLDERS = 'Add new placeholders';
export const CHILD_ASINS = 'ASINs';
export const VENDOR_PLACEHOLDERS = 'Vendor placeholders';
export const PLACE_CHILD_ASINS = 'Place all ASINs';
export const PLACE_PLACEHOLDERS = 'Place all placeholders (style code and color) in format: styleCode | color';
export const COPY_ADD_CHILD_ASINS = 'Copy and paste all ASINs you wish to add below separated by spaces';
export const COPY_ADD_PLACEHOLDERS =
  'Copy and paste all placeholders (style code and color) you wish to add below separated by commas in format: styleCode | color';
export const SAVE_ATTRIBUTES = 'Save Attributes & Add';
export const CONFIRM_ADD_ASIN = 'Add ASINs to SuperCat';
export const CONFIRM_ADD_PLACEHOLDERS = 'Add placeholders to SuperCat';
export const ENTER_ATTRIBUTES = 'Enter attributes to populate the same placeholder type';
export const VENDOR_NEED_ATTRIBUTES = 'Every row must have a brand, status, and newness entered';

// SuperCat column IDs/fields
export const COL_IMAGE_URL = 'imageUrl';
export const COL_ADDED_DATE = 'addedDate';
export const COL_TEEN_ASIN = 'teenAsin';
export const COL_PRODUCT_PLACEHOLDER = 'productPlaceholder';
export const COL_BRAND = 'brand';
export const COL_VENDOR_CODE = 'vendorCode';
export const COL_RELATIONSHIP = 'relationship';
export const COL_STATUS = 'status';
export const COL_PARENT_ASIN = 'parentAsin';
export const COL_EXAMPLE_CHILD_ASIN = 'exampleChildAsin';
export const COL_CHILD_ASIN_COUNT = 'childAsinCount';
export const COL_CHILD_ASIN_SIZES = 'childAsinSizes';
export const COL_VENDOR_STYLE = 'vendorStyle';
export const COL_STYLE_NAME = 'styleName';
export const COL_VENDOR_COLOR = 'vendorColor';
export const COL_SIMPLE_COLOR = 'simpleColor';
export const COL_PRICE = 'price';
export const COL_NEWNESS = 'newness';
export const COL_AVAILABLE_RETAIL_DATE = 'availableRetailDate';
export const COL_SHIP_WINDOW_START_DATE = 'shipWindowStartDate';
export const COL_SHIP_WINDOW_END_DATE = 'shipWindowEndDate';
export const COL_IS_FAST_TRACK = 'isFastTrack';
export const COL_NOTES = 'notes';
export const COL_GL = 'GL';
export const COL_DEPARTMENT = 'department';
export const COL_MERCH_LOCATION = 'merchLocation';
export const COL_MERCH_LOCATION_PLACHOLDER = 'Merch Location?';
export const COL_MERCH_LOCATION_HEADER = 'Merch Location';
export const COL_CATEGORY = 'styleCategory';
export const COL_CATEGORY_PLACHOLDER = 'Category?';
export const COL_CATEGORY_HEADER = 'Category';
export const COL_SUB_MERCH_LOCATION = 'subMerchLocation';
export const COL_SUB_MERCH_LOCATION_PLACHOLDER = 'Sub-Category?';
export const COL_SUB_MERCH_LOCATION_HEADER = 'Sub-category';
export const COL_DOOR = 'door';
export const COL_DOOR_PLACEHOLDER = 'Door?';
export const COL_DOOR_HEADER = 'Door';
export const COL_STORES = 'stores';
export const COL_INBOUND_MONTH = 'inboundMonth';
export const COL_OUTBOUND_MONTH = 'outboundMonth';
export const COL_AMT_START_DATE = 'amtStartDate';
export const COL_AMT_END_DATE = 'amtEndDate';
export const COL_WEEKS_ON_FLOOR = 'weeksOnFloor';
export const COL_LIFECYCLE = 'lifeCycle';
export const COL_STORES_UPDATED_DATE = 'updatedDate';
export const COL_PRESENTATION_STOCK_NAME = 'presentationStockName';
export const COL_FALLOUT_REASON = 'falloutReason';
export const COL_STYLE_ZONE_NAME = 'styleZoneName';
export const COL_FEATURE_MERCH = 'featureMerch';
export const COL_MATCHING_SET_NAME = 'matchingSetName';
export const COL_SILHOUETTE = 'silhouette';
export const COL_RISE_FOR_DENIM = 'riseForDenim';
export const COL_PRIMARY_STORY = 'primaryStory';
export const COL_STYLE_RANK = 'styleRank';
export const COL_COLOR_RANK = 'colorRank';
export const COL_IS_FN_SKU_FBA = 'isFnSkuFBA';
export const COL_MCID = 'MCID';
export const COL_OMCID = 'OMCID';
export const COL_NEED_ATTENTION = 'needAttention';
export const COL_IS_FORECASTING_AVAILABLE = 'isForecastingAvailable?';
export const COL_UPHL1 = 'uphl1';
export const COL_UPHL2 = 'uphl2';
export const COL_UPHL3 = 'uphl3';
export const COL_LAST_UPDATED_TIMESTAMP = 'lastUpdatedTimestamp';

// Column headers
export const COL_HEADER_AVAILABLE_RETAIL_DATE = 'Launch Date on .com';
export const COL_HEADER_AMT_START = 'AMT Start Date';
export const COL_HEADER_AMT_END = 'AMT End Date';
export const COL_HEADER_SHIP_WINDOW_START = 'Ship Window Start Date';
export const COL_HEADER_SHIP_WINDOW_END = 'Ship Window End Date';
export const COL_HEADER_FALLOUT_REASON = 'Fallout Reason';

// SuperCat Action btn
export const EXPORT_AMT = 'Export to AMT';
export const EXPORT_ISM = 'Export for Forecasting ';
export const EXPORT_PLACEHOLDER = 'Export Placeholders';
export const REMEMBER_TO_SAVE_WARN_MSG = "Your work hasn't been saved. Please save your changes before continuing!";
export const SAVE_BTN_CLICKED = 'Save Btn Clicked';

// SuperCat filter
export const SHOW_THESE_COLUMNS = 'Show these columns';
export const FILTER_BY = 'Filter By';
export const RESET_ALL_FILTERS = 'Reset all filters';
export const CLEAR_ALL_FILTERS = 'Clear all filters';

// SuperCat Confirmation pop up related
export const CONFIRM_REMOVAL_FROM_SEASON_TEXT = 'Confirm removal from season';
export const CONFIRMATION_YES_BUTTON_TEXT = 'Yes, Delete';
export const CONFIRMATION_NO_BUTTON_TEXT = 'No, Cancel';

// AMT related
export const CAT_ACCESSORIES = 'accessories';
export const SUB_CAT_DENIM = 'denim';

// Dev Tool - Kbar
export const KBAR_SECTION_NAME = 'Feature Gating';
export const LOCAL_STORAGE_PREFIX = 'featureGating-';

// cell value validation message
export const NEEDS_ATTENTION = 'Needs attention';
export const MISSING_REQUREID_FIELD = 'This field is required';
export const INCORRECT_ASIN_FORMAT = 'Incorrect asin format';
export const INVALID_NUMBER = 'Invalid number';
export const INVALID_DATE_FORMAT = 'is invalid, acceptable date formats are [MM/DD/YYYY, M/D/YY, M/D/YYYY, MM/DD/YY]';
export const TEENASIN_OR_PRODUCTPLACEHOLDER_SHOULD_EXIST = 'Teen asin or product placeholder should exist';

// error
export const UNABLE_TO_LOAD = 'Unable to load results. Please try again.';
export const UNEXPECTED_ERROR = 'Unexpected error. Please report the issue.';
export const CUT_TT = 'Cut a Trouble Ticket';
export const UNABLE_TO_LOAD_SUPERCAT_TABLE = 'Unable to load table. Please reopen the Assortment list to reload';
export const FAILED_CREATE_ASSORTMENT = 'Failed to create assortment';
export const FAILED_ADD_ENTRY = 'Failed to add entries';
export const INVALID_ENTRIES_IGNORED = 'Following entries are ignored because that are not valid asins:';
export const NO_PROGRAM_SELECTED = 'No Program Selected';
export const DUPLICATE_ENTRY_MSG = 'An entry already exist for the following:';
export const RETRYABLE_MSG = 'Please retry the following entries:';
export const USER_PERMISSION_MSG = 'You do not have permission to add the following entries:';
export const NO_CATALOG_FOUND_MSG = 'No product information was found for the following entries:';
export const VALIDATION_MSG = 'The following entries were invalid:';
export const GENERAL_ERROR_MSG = 'Something went wrong with the following entries:';
export const REPORT_ISSUE_MSG = 'Please contact our team by reporting an issue';
export const RETRY_OR_REPORT = 'Please correct the info and retry. If you still see errors, please report an issue.';
export const PERMISSION_SUPPORT =
  'If you feel you should have the permission, please contact us to check or grant you proper permission';
export const FAILED_TO_SAVE = 'Failed to save changes';
export const FETCH_AMT_INBOUND_OUTBOUND_MAPPING_FAILED = 'Failed to fetch AMT inbound outbound date mapping.';
export const FAILED_TO_EXPORT = 'Unable to export: ';
export const FAILED_TO_UPLOAD = 'Unable to upload: ';
export const BAD_REQUEST_MSG = 'The following entrires have invalid attributes to update:';
export const DEPENDENCY_ERR_MSG =
  'The following entries have failed to update because dependent service returned an exception:';
export const STORE_SCHEDULE_INVALID = 'Please input Inbound Month, Outbound Month, AMT Start Date, and AMT End Date';
export const PARSING_NIS_MAPPING_ERR_MSG = 'Failed to parse the NIS mapping excel, please check the content';
export const FAILED_TO_FIND_NIS_MAPPING_ERR_MSG = 'For bulk NIS mapping failed to find placeholder in this list: ';
export const EDIT_INVALID_SELECTED_OPTIONS =
  'has the following invalid options and they have been removed from your selected options:';
export const BULK_EDIT_CANT_SELECT_THIS_OPTION = 'Bulk edit cannot select this option';
export const BULK_EDIT_CANT_SELECT_REASON =
  ", because it's not available in other selected products, please select another one";

export const NO_ENTRIES_PRESENT = 'No entries are present to update';
export const CHILD_ASIN_REQUIRED = 'Child ASIN /Child Placeholder is required';
export const CONTACT_EMAIL = 'ihm-assortment-tech@amazon.com';
export const FORECASTING_UPLOAD_MESSAGE = 'Success. Forecasting data uploaded.';
export const YES_MESSAGE = 'Yes';
export const NO_MESSAGE = 'No';
export const BULK_EDIT_NOT_FROM_USER_ACTION = 'BulkEditNotFromUserAction';

// Rollups related
export const ROLLUPS = 'Rollups';
export const MY_CONTRIBUTION = 'My contribution';
export const TEAM_PROGRESS = 'Team Progress';
export const TEEN_TARGET_HEADING = 'Teen Target';
export const CHILD_ASIN_HEADING = 'Child asin';
export const POR_HEADING = 'POR';
export const CATEGORIES_HEADING = 'Categories';
export const SUBCATS_HEADING = 'Subcats';
export const STYLE_ZONE_HEADING = 'Style Zones';
export const PRICE_BUCKETS_HEADING = 'Price Buckets';
export const NEWNESS_HEADING = 'Newness';
export const BRAND_HEADING = 'Brand';
export const ACTUAL_TEXT = 'Actual';
export const TARGET_TEXT = 'Target';
export const ON_TARGET_TEXT = 'On target';

// Agile Upload Col related
export const COL_STORE_ID = 'storeId';
export const COL_ZONE = 'zone';
export const COL_LIVE_DATE = 'liveDate';
export const COL_ASIN = 'asin';
export const COL_FACE_UNITS = 'faceUnits';

export const INDEFINITE_TIME = 32506855650000;
